<script setup>
  import { computed } from "vue";

  import { Badge } from "@/components/ui/badge";

  const props = defineProps({
    status: { type: String, required: true },
  });

  const badgeVariant = computed(() => (props.status === "active" ? "info" : "outline"));
  const badgeClass = computed(() =>
    props.status === "active" ? "" : "bg-muted text-muted-foreground border-border hover:bg-muted",
  );
</script>

<template>
  <Badge
    :variant="badgeVariant"
    :class="badgeClass">
    {{ status }}
  </Badge>
</template>
